const inBrowser = typeof window !== 'undefined';

const removeClass = function(cls, el) {
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(' ' + clsName + ' ', ' ');
    }
  }
  if (!el.classList) {
    el.className = trim(curClass);
  }
}

const addClass = function(cls, el) {
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += ' ' + clsName;
    }
  }
  if (!el.classList) {
    el.className = curClass;
  }
}

const hasClass = function(cls, el) {
  return el.className.indexOf(cls) > -1;
}

const setHtmlClass = (val) => {
  if (!val || !inBrowser) {
      return;
  }
  let _className = document.documentElement.className;
  if (_className.indexOf(val) >= 0) {
      return;
  }
  _className = _className + " " + val;
  document.documentElement.className = _className;
}

const removeHtmlClass = (val) => {
  if (!val || !inBrowser) {
      return;
  }
  let _className = document.documentElement.className;
  if (_className.indexOf(val) == -1) {
      return;
  }
  _className = _className.replace(val, '');
  document.documentElement.className = _className;
}

const setDocumentTitle = (val) => {
  if (!val || !inBrowser) {
      return;
  }

  document.title = val;
}

const m = {
  removeClass,
  addClass,
  hasClass,
  setHtmlClass,
  removeHtmlClass,
  setDocumentTitle
}

module.exports = m;